import { render, staticRenderFns } from "./htmlTemplate4.vue?vue&type=template&id=ba0913d4&scoped=true"
import script from "./htmlTemplate4.vue?vue&type=script&lang=js"
export * from "./htmlTemplate4.vue?vue&type=script&lang=js"
import style0 from "./htmlTemplate4.vue?vue&type=style&index=0&id=ba0913d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0913d4",
  null
  
)

export default component.exports